var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogo = function SvgLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 203.3 169.9",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#5acaeb;}.cls-3{fill:#0498c2;}.cls-4{fill:url(#New_Pattern_Swatch_12);}.cls-5{fill:url(#New_Pattern_Swatch_9);}"), /*#__PURE__*/React.createElement("pattern", {
    id: "New_Pattern_Swatch_12",
    "data-name": "New Pattern Swatch 12",
    width: 30,
    height: 30,
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 30 30"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 30,
    height: 30
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "New_Pattern_Swatch_9",
    "data-name": "New Pattern Swatch 9",
    width: 30,
    height: 30,
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 30 30"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "164.18 24.55 182.6 22.5 164.18 20.45 172.29 10.31 162.15 18.42 160.1 0 158.05 18.42 147.9 10.31 156.01 20.45 137.59 22.5 156.01 24.55 147.9 34.7 158.05 26.59 160.1 45.01 162.15 26.59 172.29 34.7 164.18 24.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "183.7 44.26 188.64 43.71 183.7 43.16 185.88 40.44 183.15 42.62 182.6 37.67 182.05 42.62 179.33 40.44 181.51 43.16 176.56 43.71 181.51 44.26 179.33 46.99 182.05 44.81 182.6 49.75 183.15 44.81 185.88 46.99 183.7 44.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "196.25 11.57 203.3 10.78 196.25 10 199.35 6.11 195.47 9.22 194.68 2.17 193.9 9.22 190.01 6.11 193.12 10 186.07 10.78 193.12 11.57 190.01 15.45 193.9 12.35 194.68 19.4 195.47 12.35 199.35 15.45 196.25 11.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "127.45 68.63 137.2 43.71 87.8 57.54 127.45 68.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "87.8 57.54 38.39 43.71 48.15 68.63 87.8 57.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "87.8 57.54 137.2 43.71 38.39 43.71 87.8 57.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "175.59 82.1 137.2 43.71 127.45 68.63 175.59 82.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "48.15 68.63 38.39 43.71 0 82.1 48.15 68.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "0 82.1 87.8 169.9 48.15 68.63 0 82.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "127.45 68.63 99.53 158.16 175.59 82.1 127.45 68.63"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo.924bff5c11aa32b8168cd4b09daeffb9.svg";